import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors';
import { IState } from 'shared/store';

export const CPD_LABEL_EXPERIMENT = 'sel_cpd_label';

export const selectIsCpdLabelExperiment = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, CPD_LABEL_EXPERIMENT, 'B');
};
